export default __webpack_public_path__ + "static/media/home-testimonial.a6ffff7a.jpg";